import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, NavigationStart } from '@angular/router';

import { FuseConfigService } from '@fuse/services/config.service';
import { fuseAnimations } from '@fuse/animations';
import { UserFLT } from 'app/model/userflt.model';
import { AppService } from 'app/app.service';



@Component({
  selector: 'fltlogin',
  templateUrl: './fltlogin.component.html',
  styleUrls: ['./fltlogin.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class FLTLoginComponent implements OnInit {
  fltloginForm: FormGroup;
  user: any;
  message:  string = '';
   /**
   * Constructor
   *
   * @param {FuseConfigService} _fuseConfigService
   * @param {FormBuilder} _formBuilder
   */
  constructor(
    private _fuseConfigService: FuseConfigService,
    private _formBuilder: FormBuilder,
    private _appService : AppService,
    

  ) {
    this.user = new UserFLT();
    this.fltloginForm = this.createControlForm();

    // Configure the layout
    this._fuseConfigService.config = {
      layout: {
        navbar: {
          hidden: true
        },
        toolbar: {
          hidden: true
        },
        footer: {
          hidden: true
        },
        sidepanel: {
          hidden: true
        }
      }
    };
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {


    this.fltloginForm = this._formBuilder.group({
      Email: ['', [Validators.required, Validators.email]],
      Password: ['', Validators.required]
    });

  }

  logar() {
    if (this.fltloginForm.invalid) return;

    var usuario = this.fltloginForm.getRawValue() as UserFLT;
    this._appService.logar(usuario).then((response) => {
      if(response == undefined) { 
        this.message = 'Usuário ou Senha inválidos';
      } 
      else 
      {
        
      }
    });
  }

  createControlForm(): FormGroup {
    return this._formBuilder.group({

      Email: [this.user.Email],
      Password: [this.user.Password]
    });
  }
}
